<template>
  <div class="backdrop">
    <div class="backdrop-top">
      <div class="title-box">
        <img src="../../../assets/images/return.png" @click="$router.go(-1)"><span>添加耗材盘点单</span>
      </div>
      <div class="list-wrapper">
        <div class="row-item">
          <label>盘点单名称</label>
          <input type="text" v-model.trim="stocktaking_title" placeholder="请输入盘点单名称" >
        </div>
        <div class="row-item" @click="warehouseClick">
          <label>盘点仓库</label>
          <input type="text" v-model="storage_name" placeholder="请选择盘点仓库" readonly>
          <img src="../../../assets/images/right_jt.png">
        </div>
        <div class="row-item">
          <label style="flex: 1">是否允许手工盘点</label>
          <mt-switch v-model="handwork_allow"></mt-switch>
        </div>
        <div class="row-item" style="margin-top: 8px;color: #8c8c8c;">盘点范围</div>
        <div class="row-item">
          <label style="flex: 1">仅盘点有库存耗材</label>
          <mt-switch v-model="inventory_exist"></mt-switch>
        </div>
        <div class="row-item" @click="classifyClick">
          <label>耗材分类</label>
          <input type="text" v-model="category_name" placeholder="请选择耗材分类" readonly>
          <img src="../../../assets/images/right_jt.png">
        </div>
      </div>
    </div>
    <button class="preserve" @click="commit">创建盘点单</button>

    <!-- 选择盘点仓库 -->
    <div class="select-mask" v-if="warehousePopup">
      <div class="select-mask-blank" @click="clickBlank"></div>
      <div class="select-mask-inner">
        <div class="select-mask-content">
          <div class="head-mask">选择盘点仓库<img class="close-mask" @click="warehouseClose" src="../../../assets/images/close.png"></div>
          <el-tree :data="warehouseData" :props="defaultProps" :expand-on-click-node="false" node-key="id" @node-click="selectStorage"></el-tree>
        </div>
      </div>
    </div>

    <!-- 选择耗材分类 -->
    <div class="select-mask" v-if="classifyPopup">
      <div class="select-mask-blank" @click="clickBlank"></div>
      <div class="select-mask-inner">
        <div class="select-mask-content">
          <div class="head-mask">选择耗材分类<img class="close-mask" @click="classifyClose" src="../../../assets/images/close.png"></div>
          <el-tree :data="classifyData" :props="defaultProps" :expand-on-click-node="false" node-key="id" @node-click="selectCategory"></el-tree>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'AssetStocktakingAdd',
  metaInfo: {
    title: '添加耗材盘点单'
  },
  computed: {
    ...mapState(['villageId', 'memberId'])
  },
  created () {
    // 解决安卓软键盘弹出布局问题
    let bodyHeight = document.documentElement.clientHeight + 'px'
    window.addEventListener('resize', () => {
      document.body.style.height = bodyHeight
    })

    this.getStorageTree()
    this.getCategoryTree()
  },
  data () {
    return {
      stocktaking_title: '',
      storage_id: 0,
      storage_name: '',
      handwork_allow: false,
      inventory_exist: false,
      category_id: 0,
      category_name: '',
      warehousePopup: false, // 仓库
      warehouseData: [],
      classifyPopup: false, // 分类
      classifyData: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      }
    }
  },
  methods: {
    getStorageTree () {
      this.axios.post('/wechat/basic_info/getStorageTree', {
        member_id: this.memberId,
        village_id: this.villageId
      }).then((res) => {
        if (res.data.status === 1) {
          this.warehouseData = res.data.data
        }
      })
    },
    getCategoryTree () {
      this.axios.post('/wechat/basic_info/getCategoryTree', {
        member_id: this.memberId,
        village_id: this.villageId
      }).then((res) => {
        if (res.data.status === 1) {
          this.classifyData = res.data.data
        }
      })
    },
    commit () {
      if (this.stocktaking_title === '') {
        this.$toast({
          message: '请输入盘点单名称',
          duration: 3000
        })
        return false
      }
      if (this.storage_id === 0) {
        this.$toast({
          message: '请选择仓库',
          duration: 3000
        })
        return false
      }
      this.axios.post('/wechat/stocktaking/addStocktaking', {
        member_id: this.memberId,
        village_id: this.villageId,
        stocktaking_title: this.stocktaking_title,
        storage_id: this.storage_id,
        handwork_allow: this.handwork_allow,
        inventory_exist: this.inventory_exist,
        category_id: this.category_id
      }).then((res) => {
        if (res.data.status === 1) {
          this.$toast({
            message: '创建成功',
            duration: 5000
          })
          this.$router.go(-1)
        } else {
          this.$toast({
            message: res.data.info,
            duration: 5000
          })
        }
      }).catch(() => {
        this.$toast({
          message: '网络错误',
          duration: 5000
        })
      })
    },

    // 点击盘点仓库
    warehouseClick () {
      this.warehousePopup = true
    },
    // 关闭盘点仓库弹出
    warehouseClose () {
      this.warehousePopup = false
    },
    // 点击分类
    classifyClick () {
      this.classifyPopup = true
    },
    // 关闭分类弹出
    classifyClose () {
      this.classifyPopup = false
    },
    // 点击空白地方关闭
    clickBlank () {
      this.warehousePopup = false
      this.userPopup = false
      this.classifyPopup = false
      this.areaPopup = false
    },
    selectStorage (data) {
      this.storage_id = data.id
      this.storage_name = data.label
      this.clickBlank()
    },
    selectCategory (data) {
      this.category_id = data.id
      this.category_name = data.label
      this.clickBlank()
    }
  }
}
</script>
<style scoped>
.backdrop {
  background-color: #f6f6f6;
  overflow: hidden;
}
.backdrop-top {
  height: calc(100% - 50px);
  overflow-y: auto;
}
.preserve {
  width: 100%;
  height: 50px;
  border: none;
  font-size: 16px;
  letter-spacing: 2px;
  color: #ffffff;
  background-color: #ff7c12;
}
.list-wrapper .row-item {
  display: flex;
  /* margin: 0 15px; */
  padding: 10px 15px;
  border-bottom: 1px solid #f6f6f6;
  font-size: 15px;
  background-color: #ffffff;
}
.list-wrapper .row-item input {
  flex: 1;
  width: 100%;
  border: none;
  outline: none;
  font-size: 15px;
  text-align: right;
  padding: 0;
}
.list-wrapper .row-item img {
  width: 12px;
  height: 12px;
  vertical-align: top;
  padding: 5px 0 0 5px;
}
.select-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 1;
}
.select-mask .select-mask-blank {
  width: 100%;
  height: 100%;
}
.select-mask .select-mask-inner {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #ffffff;
  font-size: 15px;
  height: 300px;
  overflow-y: auto;
}
.select-mask .select-mask-inner .select-mask-content {
  padding: 0 15px;
}
.select-mask .select-mask-inner .head-mask {
  text-align: center;
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #f6f6f6;
  position: relative;
}
.select-mask .select-mask-inner .head-mask .close-mask {
  width: 18px;
  height: 18px;
  position: absolute;
  top: 12px;
  right: 10px;
}
.select-mask .select-mask-inner .select-mask-content .level {
  border-bottom: 1px solid #f6f6f6;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  position: relative;
}
.select-mask .select-mask-inner .select-mask-content label {
  display: block;
  border-bottom: 1px solid #f6f6f6;
  padding: 5px 15px;
}
>>>
.mint-switch-core {
  width: 42px;
  height: 22px;
}
>>>
.mint-switch-core::before {
  width: 40px;
  height: 20px;
}
>>>
.mint-switch-core::after {
  width: 20px;
  height: 20px;
}
>>>
.el-tree-node__expand-icon {
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/Material/Stocktaking/StocktakingAdd.vue